import type { Order, Orders } from '../../../Tab.types'

export function canOrderBeConfirmed(order: Order) {
  return (
    ['MERCHANT_NEED_TO_SEND', 'SENT'].includes(order.state.code) &&
    Boolean(order.deliveryFormLink)
  )
}

export function getData(orders: Orders) {
  const orderIdsToValidate: number[] = []
  const ordersThatCanNotBeConfirmed: Orders = []

  orders.forEach((order) => {
    if (canOrderBeConfirmed(order)) {
      orderIdsToValidate.push(order.id)
    } else {
      ordersThatCanNotBeConfirmed.push(order)
    }
  })

  return { orderIdsToValidate, ordersThatCanNotBeConfirmed }
}
